import { ImportExportHistoriesColumn } from '@/features/import_export_histories/type';
import { formatFileSize } from '@/utils/convert/formatFileSize';
import { FC, memo } from 'react';

type Props = {
  row: ImportExportHistoriesColumn;
};

export const FileSizeCell: FC<Props> = memo(({ row }) => {
  const { byte_size, type } = row;
  const hasNoData =
    byte_size === null || byte_size === undefined || type === 'export';

  if (hasNoData) {
    return <span>--</span>;
  }

  return <span>{formatFileSize(byte_size)}</span>;
});

FileSizeCell.displayName = 'FileSizeCell';
